module.exports = __webpack_public_path__ + "img/portfolio-big-01.8dee6369.jpg";